/**
 * author: omarg
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");

    var BillingDetailsModel = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        BillingDetailsModel = BaseModel.extend({
            name: "BillingDetailsModel",
            fetch: function(options) {
                options = options || {};
                options.headers = {
                    'Accept': 'application/json'
                };
                this.resource= {};
                if(options && options.creditCardRef){
                    this.resource.url = ApiResources.Billing.BillingPaymentDetailsTrial.url.replace("{pmi}", options.creditCardRef);
                }else{
                    this.resource.url = ApiResources.Billing.BillingPaymentDetailsPaying.url.replace("{accountId}", LE.loginInfo.accountId);
                }
                BaseModel.prototype.fetch.call(this, options);
            }
        });
    });

    return BillingDetailsModel;
});
